import { apiFetch } from "@core/index";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiEndpoint } from "../utils/constants";

// Delete a title configuration by id
export const useDeleteTitleConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: { id: string }) => {
      const response = await apiFetch<{
        statusCode: number;
        message: string;
      }>(`${apiEndpoint}/${config.id}`, {
        method: "DELETE",
      });
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message, {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Title configuration deleted successfully", {
          variant: "success",
          autoHideDuration: 2000,
        });
        queryClient.invalidateQueries({ queryKey: ["titleConfigurationList"] });
      }
    },
    onError: (error: Error) => {
      console.error("Failed to delete title configuration:", error.message);
      enqueueSnackbar(error.message, {
        variant: "error",
        autoHideDuration: 5000,
        preventDuplicate: true,
      });
    },
  });
};
